<template>
  <div>
    <div class="card card-primary">
      <div class="card-header pt-2 pb-2">
        <a
          data-toggle="collapse"
          href="#lineas_negocio"
          aria-expanded="true"
          id="heading-lineas_negocio"
          class="d-block"
        >
          <i class="fa fa-chevron-down pull-right"></i>
          Lineas Negocio
        </a>
      </div>
      <div id="lineas_negocio" class="collapse">
        <div class="card-body">
          <div class="row" v-for="linea in listasForms.lineas" :key="linea.id">
            <div class="form-group">
              <div
                class="
                  custom-control
                  custom-switch
                  custom-switch-off-secundary
                  custom-switch-on-success
                "
              >
                <input
                  :disabled="
                    ($parent.form.categoria_licencia !== 8 && linea.id === 2) ||
                    (!$parent.form.id && !$store.getters.can('argentina.choferes.create')) ||
                    ($parent.form.id && !$store.getters.can('argentina.choferes.edit'))
                  "
                  type="checkbox"
                  class="custom-control-input"
                  :id="'linea_' + linea.id"
                  @change="actualizarLinea(linea.id)"
                  v-model="form.linea[linea.id]"
                  :checked="linea.estado"
                />
                <label
                  class="custom-control-label"
                  :for="'linea_' + linea.id"
                  >{{ linea.nombre }}</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ChoferLinea",
  data() {
    return {
      form: {
        linea: [],
      },
      listasForms: {
        lineas: [],
      },
      cargando: false,
    };
  },
  methods: {
    actualizarLinea(linea) {
      // Verificar permisos antes de proceder
      if (!this.$parent.form.id && !this.$store.getters.can('argentina.choferes.create')) {
        return;
      }
      if (this.$parent.form.id && !this.$store.getters.can('argentina.choferes.edit')) {
        return;
      }

      if (this.$parent.form.categoria_licencia !== 8) {
        this.form.linea[2] = false;
      }

      // Si no hay ID (está creando), solo actualizar el estado localmente
      if (!this.$parent.form.id) {
        // Solo mantener el estado local, se guardará cuando se cree el conductor
        // Notificar al padre si hay al menos una línea seleccionada
        this.$nextTick(() => {
          const lineasSeleccionadas = this.getLineasSeleccionadas();
          this.$parent.lineasSeleccionadas = lineasSeleccionadas.length > 0;
        });
        return;
      }

      // Si hay ID (está editando), guardar inmediatamente
      axios
        .put("/api/argentina/choferes/assingOrRevokeLinea", {
          conductor_id: this.$parent.form.id,
          linea: linea,
          accion: this.form.linea[linea],
        })
        .then((response) => {
          this.$parent.$refs.ChoferDocumento.getPaquetes(),
            this.$parent.$refs.ChoferDocumento.getChofer(
              this.$parent.form.id
            );
          this.$swal({
            icon: "success",
            title: response.data.msg,
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        });
    },
    
    // Método para obtener las líneas seleccionadas (usado al crear)
    getLineasSeleccionadas() {
      const lineasSeleccionadas = [];
      for (const lineaId in this.form.linea) {
        if (this.form.linea[lineaId] === true) {
          lineasSeleccionadas.push(parseInt(lineaId));
        }
      }
      return lineasSeleccionadas;
    },
    getLineasChofer() {
      // Si no hay ID (creando), cargar todas las líneas sin estado
      if (!this.$parent.form.id) {
        axios.get("/api/admin/lineasNegocios/lista").then((response) => {
          this.listasForms.lineas = response.data.map(linea => ({
            id: linea.id,
            nombre: linea.nombre,
            estado: false
          }));
          
          for (let i = 0; i < this.listasForms.lineas.length; i++) {
            const linea = this.listasForms.lineas[i];
            this.form.linea[linea.id] = false;
          }
        });
        return;
      }

      // Si hay ID (editando), cargar líneas con estado del chofer
      let data = [];
      axios
        .get("/api/argentina/choferes/lineas?chofer=" + this.$parent.form.id)
        .then((response) => {
          this.listasForms.lineas = response.data;

          for (let i = 0; i < this.listasForms.lineas.length; i++) {
            const linea = this.listasForms.lineas[i];
            this.form.linea[linea.id] = linea.estado;
          }
        });
    },
  },
  mounted() {
    this.getLineasChofer();
  },
  watch: {
    '$parent.form.id': function(newVal, oldVal) {
      // Si el ID cambia de null a un valor (después de crear), recargar las líneas
      if (oldVal === undefined && newVal) {
        this.getLineasChofer();
      }
    }
  }
};
</script>
